import(/* webpackMode: "eager", webpackExports: ["PageView"] */ "/var/www/light_of_empire_front/widgets/PageView/PageView.tsx");
